import { render } from "./SimpleSelect.vue?vue&type=template&id=3cf174e4&scoped=true"
import script from "./SimpleSelect.vue?vue&type=script&lang=js"
export * from "./SimpleSelect.vue?vue&type=script&lang=js"

import "./SimpleSelect.vue?vue&type=style&index=0&id=3cf174e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf174e4"]])

export default __exports__